import { useTranslation } from '@/i18n';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useCallback } from 'react';

export type IpAddressWhitelistMutationToastKind = 'add' | 'update' | 'delete';

const TOAST_KEY: Record<IpAddressWhitelistMutationToastKind, string> = {
  add: 'ip_address_whitelist_toast_add_success',
  update: 'ip_address_whitelist_toast_update_success',
  delete: 'ip_address_whitelist_toast_delete_success',
};

export const useIpAddressWhitelistMutationSuccessToast = () => {
  const { t } = useTranslation();
  const notify = useToastAPI();

  const notifyMutationSuccess = useCallback(
    (kind: IpAddressWhitelistMutationToastKind) => {
      notify.success({ title: t(TOAST_KEY[kind]), duration: 5 });
    },
    [notify, t]
  );

  return { notifyMutationSuccess };
};
